<template>
    <div id="FileManagement">
        <dashboardMenu @updateCategories="[]" />

        <div class="container">
            <div class="row mb-4 align-items-center">
                <div class="col">
                    <h3>Redirecionamentos</h3>
                </div>
                <div class="col-12 col-md-auto">
                    <span class="pointer btn btn-primario py-2" @click="handleNewRedirect">
                        <i class="fal fa-plus"></i> Novo
                    </span>
                </div>
            </div>

            <div v-if="loading" class="text-center">
                <i class="fal fa-spinner fa-spin fa-2x"></i>
            </div> 

            <div v-else-if="routes.length == 0">
                <p>Você ainda não possui redirecionamentos de url cadastrados. Clique no botão "Novo" para criar um redirecionamento.</p>
            </div>

            <template v-else>
                <div class="row">
                    <div class="col-5">
                        <small class="subtitle">URL Acessada</small>
                    </div>

                    <div class="col-5">
                        <small class="subtitle">Destino</small>
                    </div>
                </div>
                <div v-for="(item, index) in routes" :key="index" class="row my-2">
                    <div class="col-5">
                        <input type="text" placeholder="Ex: /exemplo/origem" class="form-control" v-model="item.from.path">
                    </div>

                    <div class="col-5">
                        <input type="text" placeholder="Ex: /exemplo-destino" class="form-control" v-model="item.to.path">
                    </div>
                    
                    <div class="col-2 text-right align-self-end">
                        <span class="pointer remove-button">
                            <i class="fal fa-trash-alt" @click="removeItem(index)"></i>
                        </span>
                    </div>

                    <div v-if="item.error" class="col-12">
                        <small class="error-message">
                            {{ item.error }}
                        </small>
                    </div>
                </div>

                
            </template>

            <div v-if="JSON.stringify(oldRoutes) != JSON.stringify(routes)" class="row my-5">
                <div class="col-12 text-center">
                    <span class="pointer btn btn-primario py-2" @click="updateRoutes">Salvar</span>
                </div>
            </div>

            <!--<div class="mt-4">
                <p>Utilize este recurso para apontar endereços(urls) antigos, que não existem mais em seu site, para o mesmo conteúdo no endereço novo. Isso faz com que o Google continue encontrado o conteúdo da sua página.</p>
            </div>-->

            
        </div>
    </div>

</template>

<script>

    import axios from "axios";
    import apiMixins from "@/mixins/apiMixins";
    import dashboardMenu from "@/components/DashboardMenu";
    import alertConfirmAction from "@/components/organisms/AlertConfirmAction";

    export default {
    name: "RedirectManager",
    data() {
        return {
            newRedirect: false,
            routes: [],
            oldRoutes: [],
            loading: true
        };
    },
    components: {
        dashboardMenu,
        alertConfirmAction
    },
    created(){
        this.loadRedirects();
    },
    methods: {
        handleNewRedirect(){
            let item = {
                from:{
                    id: null,
                    path: ''
                },
                to:{
                    id: null,
                    path: ''
                },
                error: ''
            };

            this.routes.push(item);
        },
        removeItem(index){
            this.routes.splice(index, 1);
        },
        loadRedirects(){
            this.loading = true;

            const siteId = this.$session.get("siteId");
            const token = this.$session.get("jwt");

            axios({
                method: "get",
                url: `${process.env.ROOT_API}api/site/${siteId}/route/redirect`,
                headers: {
                    Authorization: "Bearer " + token,
                }
            })
            .then(response => {
                if(response.data.status == '1'){
                    //Se o usuário não tive definido nome, aplica o nome do arquivo original
                    this.routes = response.data.data;
                    this.oldRoutes = [...response.data.data];
                }
            })
            .finally( () => {
                this.loading = false;
            });
        },
        slug(str){
            if(!str){
                return '/';
            }
            
            str = str.replace(/^\s+|\s+$/g, ''); // trim
            str = str.toLowerCase();
            
            // remove accents, swap ñ for n, etc
            var from = "àáäâèéëêìíïîòóöôùúüûñç·,:;";
            var to   = "aaaaeeeeiiiioooouuuunc----";

            for (var i=0, l=from.length ; i<l ; i++) {
                str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
            }

            str = str.replace(/\(/g, '');
            str = str.replace(/\)/g, '');

            str = str.replace(/[^a-z0-9 -|.]/g, '') // remove invalid chars
                .replace(/\s+/g, '-') // collapse whitespace and replace by -
                .replace(/-+/g, '-'); // collapse dashes

            return str;
        },
        updateRoutes(){
            this.loading = true;

            const siteId = this.$session.get("siteId");
            const token = this.$session.get("jwt");

            let routes = [];
            for (let index = 0; index < this.routes.length; index++) {
                this.routes[index].from.path = this.slug(this.routes[index].from.path);
                this.routes[index].to.path = this.slug(this.routes[index].to.path);
            }

            axios({
                method: "post",
                url: `${process.env.ROOT_API}api/site/${siteId}/route/redirect/create`,
                data: {
                    routes: this.routes
                },
                headers: {
                    Authorization: "Bearer " + token,
                    'Content-type': 'application/json'
                }
            })
            .then(response => {
                if(response.data.status == '1'){
                    //Se o usuário não tive definido nome, aplica o nome do arquivo original
                    this.routes = response.data.data;
                    //Se não houver rota com erro, atualiza o array de historico
                    let errors = response.data.data.some(item => item.error);
                    if(!errors){
                        this.loadRedirects();
                    }
                }
                this.uploadLoading = false;
            })
            .finally( () => {
                this.loading = false;
            });
        }
    }
}

</script>

<style scoped>
    .subtitle {
        margin-bottom: 0;
        font-size: 0.8rem;
        font-weight: 700;
        color: #777;
    }
</style>


// WEBPACK FOOTER //
// src/components/templates/RedirectManager.vue